import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const TooltipContext = createContext({});

export function TooltipProvider({ children }) {
  const [tooltips, setTooltips] = useState({});

  useEffect(() => {
    api.get('/api/tooltips')
      .then((res) => setTooltips(res.data.tooltips || {}))
      .catch(() => { /* fail silently — tooltips are non-critical */ });
  }, []);

  return (
    <TooltipContext.Provider value={tooltips}>
      {children}
    </TooltipContext.Provider>
  );
}

export function useTooltips() {
  return useContext(TooltipContext);
}
